import { Box, BoxProps, Flex } from '@chakra-ui/react';
import { Group } from '@visx/group';
import { Pie, degreesToRadians } from '@visx/shape';
import { ProvidedProps } from '@visx/shape/lib/shapes/Pie';
import { useMeasure } from 'react-use';

import { Data, PieArc } from './PieArc';

interface Props extends BoxProps {
  data: Data[];
  colors: string[];
  width: string;
  height: string;
  pieProps?: React.ComponentProps<typeof Pie>;
}

export const PieChart: React.FC<Props> = ({
  data,
  colors,
  width,
  height,
  pieProps = {},
  ...props
}) => {
  const [ref, { width: elementWidth, height: elementHeight }] = useMeasure();
  const yxMin = Math.min(
    elementHeight === 0 ? elementWidth : elementHeight,
    elementWidth,
  );
  const centerY = yxMin / 2;
  const centerX = yxMin / 2;

  return (
    <Box {...props}>
      <Flex
        // @ts-ignore
        ref={ref}
        alignItems="center"
        justifyContent="space-around"
        width="100%"
        height={height}
        flexDirection="row"
      >
        <svg style={{ width, height }}>
          <Group top={centerY} left={centerX}>
            <Pie
              data={data}
              pieValue={(pieValue: Data) => pieValue.value}
              pieSort={(value: number, otherValue: number) => {
                return value - otherValue;
              }}
              outerRadius={36}
              innerRadius={25.5}
              startAngle={0}
              endAngle={degreesToRadians(360)}
              {...pieProps}
            >
              {(pie: ProvidedProps<Data>) => {
                return pie.arcs.map((arc, i) => (
                  <PieArc pie={pie} arc={arc} key={i} colors={colors} />
                ));
              }}
            </Pie>
          </Group>
        </svg>
      </Flex>
    </Box>
  );
};
